"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CwPodGridColumn = _interopRequireDefault(require("./CwPodGridColumn"));

var cwPodGridLoader = function cwPodGridLoader(props) {
  // extract required props
  var maxColumns = props.maxColumns,
      children = props.children,
      customLayout = props.customLayout,
      gwtStandalonePod = props.gwtStandalonePod;

  if (customLayout) {
    // Return the custom defined layout
    return children;
  }

  var podColumns = []; // By default, add all pods to first column

  podColumns.push(_react.default.createElement(_CwPodGridColumn.default, {
    key: 0,
    gwtStandalonePod: gwtStandalonePod
  }, children)); // build rest of empty pod columns

  for (var i = 1; i < maxColumns; i++) {
    podColumns.push(_react.default.createElement(_CwPodGridColumn.default, {
      key: i
    }));
  }

  return podColumns;
};

var _default = cwPodGridLoader;
exports.default = _default;